import styled from 'styled-components';

const PageWrapper = styled.div`
  padding: 16px;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
`;

const DataRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  padding: 16px;
  
  p {
    width: 100%;
    text-align: center;
    margin: 0;
  }
  
  span {
    margin-right: 8px;
  }
  
  :not(:last-child) {
    margin-bottom: 16px;
  }
  
  max-height: 15vh;
  overflow-y: auto;
  
  div {
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight};
    padding: 8px;    
  }
`;

export const Styled = {
  PageWrapper,
  DataRow,
};
